import 'slick-carousel';

$('#product .product__slider').slick({
	slidesToShow: 1,
	slidesToScroll: 1,
	dots: false,
	arrows: false,
	infinite: false,
	adaptiveHeight: true,
	asNavFor: '#product .product__thumbs'
});

$('#product .product__thumbs').slick({
	vertical: true,
	slidesToShow: 4,
	slidesToScroll: 4,
	dots: false,
	arrows: false,
	infinite: false,
	asNavFor: '#product .product__slider',
	focusOnSelect: true,
	responsive: [
	  {
	    breakpoint: 1023,
	    settings: {
	    	vertical: false,
	    }
	  }
	]
});
